<template>
  <header class="flexbox headbox">
    <div class="">
      <router-link to="/"><img src="../../assets/img/logo.png" /></router-link>
    </div>
    <div class="stepbox">
      <el-steps :space="200" :active="1" finish-status="success" align-center>
        <el-step title="加入购物车"></el-step>
        <el-step title="填写核对订单信息"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
  </header>
  <div class="main">
    <div class="maincon">
      <div class="flexbox tabs">
        <h1>填写并核对订单信息</h1>
        <!-- <router-link to="/shoppingCart">返回购物车修改 >></router-link> -->
        <div @click="backCart" style="color: #00906f; cursor: pointer">
          返回购物车修改 >>
        </div>
      </div>
      <div class="cartbox">
        <div class="cartcon">
          <div class="flexbox overview">
            <div class="left">
              <div class="ordernum">总单号：{{ orderNum }}</div>
              <div class="ordermsg">
                <span>下单时间：{{ orderInfo.cttime }}</span>
                <span style="margin-left: 20px">拆单状态：{{ orderInfo.orderState }}</span>
              </div>
            </div>
            <div class="flexbox right">
              <p>注：</p>
              <div class="tips">
                <p>本次订单已经按照库存及产品类型进行了分单操作。</p>
                <!-- <p>1. 您本次订单包含玛钢、沟槽、阀门等<span class="redw">三类产品25个单品</span>，请您开始<span class="redw">核对本单信息。</span></p>
                                <p>2. 本次订单已经按照库存及产品类型进行了分单操作。</p>
                                <p>3. 请您对每一笔订单的<span class="redw">到货时间、开票方、抬头进行确认。</span></p>
                                <p>4. 请您核对最终的<span class="redw">优惠、商业折扣内容。</span></p> -->
              </div>
            </div>
          </div>
          <div class="ordercon">
            <div class="item" v-for="item in productList" :key="item">
              <h2 class="flexbox">
                <p>订单号：{{ item.tohSeq }}</p>
                <p>拆单时间：{{ item.cttime }}</p>
                <div>
                  <span>销售公司</span>
                  <el-select v-model="item.gsSel" size="small" @change="changeCompany($event, item)">
                    <el-option :label="gs.name" :value="gs.orgId" v-for="gs in item.companyList"
                      :key="gs.orgId"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>分销商</span>
                  <el-select v-model="item.fxs" size="small">
                    <el-option :label="fxs.name" :value="fxs.id" v-for="fxs in distributorList" :key="fxs.id"></el-option>
                  </el-select>
                </div>
              </h2>
              <div class="flexbox cell" v-for="it in item.proData" :key="it">
                <div class="flexbox msg">
                  <div class="img">
                    <img src="https://online.meide-casting.com/meide/la.img?fn" />
                  </div>
                  <div class="name">
                    <p>{{ it.name }}</p>
                    <span class="grayw">{{ it.code }}</span>
                    <span class="redw">规格：{{ it.gg }} 表面：{{ it.bm }}</span>
                  </div>
                </div>
                <!-- <div class="stock">
                                    <p class="redw">有</p>
                                    <p>库存</p>
                                </div> -->
                <div class="deliver">
                  <p class="redw">{{ it.days }}天</p>
                  <p>预计发货天数</p>
                </div>
                <div class="price">
                  <p class="redw">¥{{ it.price }}</p>
                  <p>单价</p>
                </div>
                <div class="num">
                  <p class="redw">{{ it.num }}个</p>
                  <p>数量</p>
                </div>
                <div class="cases">
                  <p class="redw">{{ it.boxNum }}箱</p>
                  <p>箱数</p>
                </div>
                <div class="weight">
                  <p class="redw">{{ it.weight }}KG</p>
                  <p>重量</p>
                </div>
                <div class="redw total">
                  <p class="redw" v-if="item.zk">¥{{ it.zk_amount }}</p>
                  <p class="redw" v-else>¥{{ it.amount }}</p>
                  <p>合计</p>
                </div>
              </div>
              <div class="flexbox note">
                <div class="flexbox notecon">
                  <span>订单备注：</span>
                  <el-input style="width: 400px" v-model="item.note" placeholder="字数限制45字" maxlength="45"></el-input>
                </div>
                <div class="flexbox notecon">
                  <span>客户订单号：</span>
                  <el-input style="width: 150px" v-model="item.customerOrderNo" placeholder="客户订单号"
                    maxlength="45"></el-input>
                </div>
                <div class="flexbox total">
                  <p>
                    重量总计：<span class="redw">{{ item.tohWeight }}KG</span>
                  </p>
                  <p>
                    共<span class="redw">{{ item.tohNum }}</span>种商品
                  </p>
                  <p v-if="item.zk">
                    小计：<span class="largew redw">¥{{ item.zk_tohAmount }}</span>
                  </p>
                  <p v-else>
                    小计：<span class="largew redw">¥{{ item.tohAmount }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pay" v-if="paymsg.xyAccount">
          <h1>支付方式</h1>
          <section v-for="(item, index) in payInfoList" :key="index">
            <div style="margin: 10px; color: red; font-size: 14px">
              {{ item.name }}
            </div>
            <div class="flexbox con">
              <div class="cell" :class="{ on: item.paySel == '1' }" @click="changePayType('1', index)">
                <div class="flexbox name">
                  <p>{{ userInfo.customerShortName }}</p>
                  <p>信用账户</p>
                </div>
                <div class="flexbox msg">
                  <!-- <img src="../../assets/img/creditacico.svg" /> -->
                  <div class="">

                    <p>
                      总欠款额：<span class="redw">¥ {{ item.data.xyAccount.totalQk }}</span>
                    </p>
                    <p>
                      超期欠款：<span class="redw">¥ {{ item.data.xyAccount.outTimeQk }}</span>
                    </p>
                    <p>
                      清欠期欠款：<span class="redw">¥ {{ item.data.xyAccount.cleanQk }}</span>
                    </p>
                    <p>
                      最长欠款天数：<span class="redw">{{
                        item.data.xyAccount.maxOutTimeDays
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="selectedico" v-if="item.paySel == '1'">
                  <img src="../../assets/img/selico.png" />
                </div>
              </div>
              <div class="cell" :class="{ on: item.paySel == '2' }" @click="changePayType('2', index)">
                <div class="flexbox name">
                  <p>{{ userInfo.customerShortName }}</p>
                  <p>普通账户</p>
                </div>
                <div class="flexbox msg">
                  <!-- <img src="../../assets/img/creditacico.svg" /> -->
                  <div class="">
                    <p>
                      余额：<span class="redw">¥ {{ item.data.ptAccount.yue }}</span>
                    </p>
                  </div>
                </div>
                <div class="selectedico" v-if="item.paySel == '2'">
                  <img src="../../assets/img/selico.png" />
                </div>
              </div>
              <div class="cell" style="border: none;" v-if="userInfo.customerCode === 'CN371613' ||
                userInfo.customerCode === 'CN371776' ||
                userInfo.customerCode === 'CN370172' ||
                userInfo.customerCode === 'CN372880'
                ">
                <div class="flexbox name">
                  <p>{{ userInfo.customerShortName }}</p>
                  <p>客户资金情况</p>
                </div>
                <div class="flexbox msg">
                  <!-- <img src="../../assets/img/creditacico.svg" /> -->
                  <div>
                    <p>
                      限额：<span class="redw">¥ {{ fundSituation.XE }}</span>
                    </p>
                    <p>
                      剩余可用余额：<span class="redw">¥ {{ fundSituation.SYKYED }}</span>
                    </p>
                    <p>
                      已有订单金额：<span class="redw">¥ {{ fundSituation.YYDDJE }}</span>
                    </p>
                    <p>
                      需汇款金额：
                      <span class="redw" v-if="fundSituation.XHKJE > 0">¥ {{ fundSituation.XHKJE }}</span>
                      <span class="redw" v-else>¥ 0</span>
                    </p>
                  </div>
                </div>
                <div class="selectedico" v-if="item.paySel == '2'">
                  <img src="../../assets/img/selico.png" />
                </div>
              </div>
              <el-button @click="handleBtn" v-if="fxsPayInfoList.length > 0" type="primary" style="margin-left: 20px">
                {{ status == "hide" ? "展开" : "收起" }}
              </el-button>
            </div>
          </section>

          <el-table v-if="fxsPayInfoList.length > 0 && showTable" :data="fxsPayInfoList" stripe
            style="width: 700px; margin-top: 30px; margin-left: 30px" :header-cell-style="{ color: '#333' }">
            <el-table-column prop="name" label="分销商" width="220" align="center">
            </el-table-column>
            <el-table-column prop="totalQk" label="总欠款额" align="center">
            </el-table-column>
            <el-table-column prop="outTimeQk" label="超期欠款" align="center">
            </el-table-column>
            <el-table-column prop="cleanQk" label="清欠期欠款" align="center">
            </el-table-column>
            <el-table-column prop="maxOutTimeDays" label="最长欠款天数" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div class="address">
          <h1>收货地址</h1>
          <div class="flexbox con" :style="{ height: adrMoreS == true ? 'auto' : '400px' }">
            <div class="cell" :class="{ on: adrSel == index }" v-for="(adr, index) in adressList" :key="adr.id"
              @click="selectItem('adr', index)">
              <div class="flexbox name">
                <p>|</p>
                <p>地址{{ index + 1 }}</p>
              </div>
              <div class="msg">
                <p>
                  {{ adr.consignee }}<span>{{ adr.telPhone }}</span>
                </p>
                <p>
                  {{ adr.province }}{{ adr.city }}{{ adr.area
                  }}{{ adr.address }}
                </p>
              </div>
              <div class="selectedico" v-if="adrSel == index">
                <img src="../../assets/img/selico.png" />
              </div>
            </div>
          </div>
          <div class="adrmore" @click="adrMoreS = !adrMoreS">
            更多地址
            <i class="el-icon-arrow-down" v-if="!adrMoreS"></i>
            <i class="el-icon-arrow-up" v-if="adrMoreS"></i>
          </div>
        </div>
        <div class="discounta" v-if="false">
          <h1>优惠信息</h1>
          <div class="flexbox con"></div>
        </div>
        <div class="discountb" v-if="false">
          <h1>商业折扣</h1>
          <div class="flexbox con"></div>
        </div>
        <div class="totalall">
          <h1>金额明细</h1>
          <div class="flexbox con">
            <p>
              <span>商品规格数：</span>
              <span class="redw">{{ orderInfo.products }}种</span>
            </p>
            <p>
              <span>商品总箱数：</span>
              <span class="redw">{{ orderInfo.totalBoxNum }}箱</span>
            </p>
            <p>
              <span>商品总重：</span>
              <span class="redw">{{ orderInfo.totalWeight }}KG</span>
            </p>
            <!-- <p>
                            <span>商品总价：</span>
                            <span class="redw">¥1245.00</span>
                        </p>
                        <p>
                            <span>活动优惠：</span>
                            <span class="redw">-¥1245.00</span>
                        </p>
                        <p>
                            <span>商业折扣：</span>
                            <span class="redw">¥1245.00</span>
                        </p> -->
            <p>
              <span>应付总额：</span>
              <span class="redw largew">¥{{ orderInfo.totalAmount }}</span>
            </p>
          </div>
        </div>
        <div class="submitbtn" @click="getInformationPrompt" v-loading="submitLoading">
          提交订单
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "axios";
import { lte } from "lodash";
export default {
  name: "Settlement",
  components: {},
  setup() {
    let { proxy } = getCurrentInstance();
    let router = useRouter();
    const submitLoading = ref(false);
    let pageData = reactive({
      userInfo: {},
      orderNum: "", // 总单号
      orderInfo: "", // 结算订单信息
      companyList: [
        // {name:"10_玫德集团2061",orgId:"11"}
      ],
      gsSel: "",
      gsSelName: "",
      distributorList: [],
      fxsSel: "",
      paymsg: [],
      paySel: "1", // 选择的支付方式
      adressList: [], // 地址列表
      adrSel: 0, // 选择的地址-下标
      productList: [], // 购买的产品
      payInfoList: [], //支付信息列表
      payIndex: 0, //选择了第几排
      fundSituation: {} //客户资金情况
    });
    // 选择地址、支付方式
    let selectItem = (type, idx, index) => {
      if (type == "adr") {
        pageData.adrSel = idx;
      } else if (type == "pay") {
        // 此处idx不是下标，是标识
        pageData.paySel = idx;
        pageData.payIndex = index;

        pageData.payInfoList[index].paySel = idx;

        if (idx == "1") {
          zkSign.value = "";
        } else {
          zkSign.value = "Y";
        }
        // getPros();
      }
    };
    //切换支付方式

    let changePayType = (idx, index) => {
      // 此处idx 1信用2普通
      //index是第几个账户信息
      // pageData.paySel = idx;
      // pageData.payIndex = index;
      //结算页有欠款的就直接不能选现金支付
      //当选择现金支付时候

      let zuzhi = false;
      if (idx == "2") {
        let qiankuan = pageData.payInfoList[index].data.xyAccount.totalQk;
        if (qiankuan > 0) {
          zuzhi = true;
        }
      }
      if (zuzhi) {
        proxy.$alert("信用账户有欠款，无法使用现金支付", "提示", {
          confirmButtonText: "确定",
          callback: (action) => { },
        });
        return;
      }

      pageData.payInfoList[index].paySel = idx;

      let orgId = pageData.payInfoList[index].orgId; //当前点击的账户的orgid
      //如果点击现金支付    找到使用这个销售公司账户的主单 把zk变为true
      let zk = false;
      if (idx == "1") {
        zk = false;
      } else {
        zk = true;
      }
      let zongjia = 0;
      pageData.productList.map((item) => {
        //如果点击现金支付    找到使用这个销售公司账户的主单 把zk变为true
        if (item.gsSel == orgId) {
          item.zk = zk;
        }
        //计算底部总价格,如果主单zk=true,那就相加主单的zk_price,如果是false,加price

        if (item.zk) {
          zongjia += item.zk_tohAmount;
        } else {
          zongjia += item.tohAmount;
        }
      });
      zongjia = zongjia.toFixed(2);
      pageData.orderInfo.totalAmount = zongjia;
    };
    // 改变公司  初始化调用  切换销售公司时也调用
    let changeCompany = (e, a) => {
      //切换公司时要将此主单的zk取消

      // if(a){
      //     a.zk=false
      // }

      //所有主单 选择的销售公司的公司id合集

      let orgIds = pageData.productList.map((item) => {
        item.zk = false; //取消所有折扣 回到信用账户 让用户重新选择
        return item.gsSel;
      });

      let zongjia = 0;

      pageData.productList.map((item) => {
        //计算底部总价格,如果主单zk=true,那就相加主单的zk_price,如果是false,加price
        if (item.zk) {
          zongjia += item.zk_tohAmount;
        } else {
          zongjia += item.tohAmount;
        }
      });
      zongjia = zongjia.toFixed(2);
      pageData.orderInfo.totalAmount = zongjia;

      let ary = [];

      orgIds.map((item) => {
        pageData.companyList.map((item2) => {
          item2.paySel = "1";
          if (item == item2.orgId) {
            ary.push(item2);
          }
        });
      });

      getPayInfoList(ary);
    };
    // 提交结算
    let submitClick = ref(true);
    let settleSubmit = () => {
      if (submitClick.value) {
        submitClick.value = true;
        let settledata = [];
        pageData.productList.map((item) => {
          let ob = {
            tohSeq: item.tohSeq, // 主单号
            note: item.note, //下单备注
            customerOrderNo: item.customerOrderNo,
            orgId: item.gsSel, // 账套
            fxs: item.fxs, // 分销商
          };
          settledata.push(ob);
        });
        for (let i = 0; i < settledata.length; i++) {
          if (settledata[i].fxs == "") {
            proxy.$alert("分销商不能为空", "提示", {
              confirmButtonText: "确定",
              callback: (action) => { },
            });
            submitClick.value = true;
            return;
          }
        }
        // if (pageData.paySel == "1") {
        //   if (
        //     parseFloat(pageData.orderInfo.totalAmount) >
        //     parseFloat(pageData.paymsg.xyAccount.syXe)
        //   ) {
        //     ElMessage({
        //       showClose: true,
        //       message: "当前余额不足，但您仍可以继续结算",
        //     });
        //   }
        // } else if (pageData.paySel == "1") {
        //   if (
        //     parseFloat(pageData.orderInfo.totalAmount) >
        //     parseFloat(pageData.paymsg.ptAccount.yue)
        //   ) {
        //     ElMessage({
        //       showClose: true,
        //       message: "当前余额不足，但您仍可以继续结算",
        //     });
        //   }
        // }
        settledata.map((item) => {
          pageData.payInfoList.map((item2) => {
            if (item.orgId == item2.orgId) {
              item.payType = item2.paySel;
            }
          });
        });

        setTimeout(() => {
          let data = {
            postType: "commitOrder", //
            hth: hth.value, // 项目合同号（结算项目订单的时候必填）
            // payType: pageData.paySel, // 支付类型（1.信用支付 2.普通支付）
            shdz:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].id
                : "", // 收货地址ID
            contactUser:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].contactUserId
                : "", // 联系人ID
            tel:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].phone
                : "", // 联系电话
            province:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].provinceId
                : "", // 省
            city:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].cityId
                : "", // 市
            area:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].areaId
                : "", // 区
            address:
              pageData.adressList.length > 0
                ? pageData.adressList[pageData.adrSel].address
                : "", // 详细地址
            fhyq: "", // 发货要求
            data: JSON.stringify(settledata),
          };

          proxy.$axios
            .postReq("/meide/REST/ajaxCommitOrder", data)
            .then((res) => {
              if (res.success == "true") {
                ElMessage.success({
                  message: res.Info,
                  type: "success",
                });
                submitClick.value = true;
                router.push({
                  name: "Successful",
                });
              } else {
                proxy.$alert(res.ErrorText, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    submitClick.value = true;
                  },
                });
              }
            })
            .catch((error) => {
              proxy.$alert(error, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  submitClick.value = true;
                },
              });
            });
        }, 600);
      }
    };
    //获取分销商的支付信息
    let fxsPayInfoList = ref([]);
    let getFxsPayInfo = (item) => {
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderInfo", {
          postType: "queryPayType",
          orgId: "11",
          fxs: item.id,
        })
        .then((res) => {
          if (res.success == "true") {
            let data = res.data.xyAccount;
            data.name = item.name;
            if (
              data.totalQk !== 0 ||
              data.outTimeQk !== 0 ||
              data.cleanQk !== 0 ||
              data.maxOutTimeDays !== 0
            ) {
              fxsPayInfoList.value.push(data);
            }
          }
        });
    };
    let status = ref("show");
    let showTable = ref(true);
    let handleBtn = () => {
      if (status.value == "hide") {
        status.value = "show";
        //隐藏
        showTable.value = true;
      } else {
        status.value = "hide";
        showTable.value = false;
      }
    };

    // 获取销售公司、分销商、支付信息、收货地址
    let adrMoreS = ref(false);
    let getPayInfoList = (ary) => {
      //公司id数组
      let list = [];
      ary.map((item) => {
        proxy.$axios
          .postReq("/meide/REST/ajaxOrderInfo", {
            postType: "queryPayType",
            orgId: item.orgId,
          })
          .then((res) => {
            list.push({
              orgId: item.orgId,
              name: item.name,
              data: res.data,
              paySel: item.paySel,
            });
            let hash = {};
            const data = list.reduce((preVal, curVal) => {
              hash[curVal.name]
                ? ""
                : (hash[curVal.name] = true && preVal.push(curVal));
              return preVal;
            }, []);
            pageData.payInfoList = data;

            moneyCaution()
            //获取玫德的支付方式
            let ZFFS = "";
            pageData.payInfoList.map((item) => {
              if (item.orgId == "11") {
                ZFFS = item.paySel;
              }
            });

            //要调用优惠券接口的参数
            let params = {
              postType: "matching",
              orderid: router.currentRoute.value.params.id,
              protype: "QT",
            };
            let data2 = [];
            pageData.productList.map((item) => {
              if (item.gsSel == "11") {
                data2.push({ ZHUORDER: item.tohSeq, ZFFS });
              }
            });
            params.data = JSON.stringify(data2);

            proxy.$axios
              .postReq("/meide/REST/ajaxmatchCoupon", params)
              .then((res) => { });
          });
      });
    };
    let getAlmost = (ptype, id, index) => {
      let data = {};
      if (ptype == "queryPayType") {
        data = {
          postType: ptype,
          orgId: pageData.gsSel,
        };
      } else if (ptype == "queryInvoice") {
        data = {
          postType: ptype,
          orderNo: id,
        };
      } else {
        data = {
          postType: ptype,
        };
      }
      proxy.$axios
        .postReq("/meide/REST/ajaxOrderInfo", data)
        .then((res) => {
          if (res.success == "true") {
            if (ptype == "queryInvoice") {
              pageData.companyList = res.data;
              pageData.gsSel = res.defaultOrgId; //默认公司
              pageData.gsSelName = res.defaultOrgName;

              getPayInfoList([
                {
                  orgId: res.defaultOrgId,
                  name: res.defaultOrgName,
                  paySel: "1",
                },
              ]);
            } else if (ptype == "queryDistributors") {
              pageData.distributorList = res.data;
              pageData.fxsSel = res.data[0].id; //默认分销商

              // res.data.map((item) => {
              //   getFxsPayInfo(item);
              // });
            } else if (ptype == "queryPayType") {
              pageData.paymsg = res.data;
            } else if (ptype == "queryAddress") {
              pageData.adressList = res.data;
            }
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => { },
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    let hth = ref("");
    // 获取产品

    let zkSign = ref("");
    let getPros = () => {
      let data = {
        // zkSign: zkSign.value,
        postType: "queryProductsList",
        orderNo: pageData.orderNum,
        // orderNo: "MD210817010",
      };
      proxy.$axios
        .postReq("/meide/REST/ajaxCommitOrder", data)
        .then((res) => {
          if (res.success == "true") {
            hth.value = res.data[0].hth;

            res.data.map((item, index) => {
              item.note = "";
              item.customerOrderNo = "";
              item.fxs = pageData.fxsSel; //默认分销商
              item.gsSel = ""; //默认销售公司
              item.tohWeight = item.tohWeight.toFixed(3);
              let zk_tohAmount = 0; //主单折扣价
              item.proData.map((item2) => {
                // item2.zkPersent = 2;  模拟的数据
                let zk_price = Number(
                  (item2.price * (100 - item2.zkPersent)) / 100
                ); //单条折扣价
                item2.zk_price = zk_price;
                item2.zk_amount = Number(
                  (zk_price * Number(item2.num)).toFixed(2)
                );
                item2.amount = Number(
                  (item2.price * Number(item2.num)).toFixed(2)
                );

                // debugger
                zk_tohAmount += item2.zk_amount;
              });
              item.zk_tohAmount = Number(zk_tohAmount.toFixed(2)); //主单折扣价格
            });

            res.totalWeight = res.totalWeight.toFixed(3);
            pageData.orderInfo = res;
            pageData.productList = res.data;

            getCompanyList(); //获取销售公司
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => { },
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    //获取每一个主单的销售公司列表，赋给主单,获取主单列表之后调用
    let getCompanyList = () => {
      pageData.productList.map((item, index) => {
        proxy.$axios
          .postReq("/meide/REST/ajaxOrderInfo", {
            postType: "queryInvoice",
            orderNo: item.tohSeq,
          })
          .then((res) => {
            if (res.success == "true") {
              item.gsSel = res.defaultOrgId; //主单默认销售公司id
              item.companyList = res.data; //主单的下拉销售公司列表
              item.defaultOrgName = res.defaultOrgName; //主单默认销售公司name
              // pageData.companyList.push(...res.data);

              let a = pageData.companyList;
              a.push(...res.data);

              let hash = {};
              const data = a.reduce((preVal, curVal) => {
                hash[curVal.name]
                  ? ""
                  : (hash[curVal.name] = true && preVal.push(curVal));
                return preVal;
              }, []);
              // console.log(data, 999999999);
              pageData.companyList = data;
              // console.log(pageData.companyList, 889988);

              // list.push({
              //             orgId: item.orgId,
              //             name: item.name,
              //             data: res.data,
              //             paySel: item.paySel,
              //           });
              //           let hash = {};
              //           const data = list.reduce((preVal, curVal) => {
              //             hash[curVal.name]
              //               ? ""
              //               : (hash[curVal.name] = true && preVal.push(curVal));
              //             return preVal;
              //           }, []);
              //           pageData.payInfoList = data;
              //         })

              // pageData.companyList = res.data;
              // pageData.gsSel = res.defaultOrgId; //默认公司
              // pageData.gsSelName = res.defaultOrgName;

              // getPayInfoList([
              //   {
              //     orgId: res.defaultOrgId,
              //     name: res.defaultOrgName,
              //     paySel: "1",
              //   },
              // ]);
              // 调用完最后一个，主单之后，再调用获取支付信息的接口
              if (index == pageData.productList.length - 1) {
                changeCompany();
              }
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
              });
            }
          })
          .catch((error) => { });
      });
    };
    //返回购物车修改
    let backCart = () => {
      let data = {
        postType: "backToShopCar",
        orderNo: pageData.orderNum,
      };
      proxy.$axios.postReq("/meide/REST/ajaxCommitOrder", data).then((res) => {
        router.push({
          name: "ShoppingCart",
        });
      });
    };
    //获取客户结算页增加①：限额、②：剩余可用额度:③：已有订单金额:④：需汇款金额
    let moneyCaution = () => {

      let data = {
        postType: 'moneyCaution',
        customerCode: pageData.userInfo.customerCode,
        customerName: pageData.distributorList[0].name,
        orgName: pageData.payInfoList[0].name
      };
      proxy.$axios.postReq("/meide/REST/ajaxCheckNumber", data).then((res) => {
        pageData.fundSituation = res.items[0]
      });
    };

    // 获取产品半年月均销量
    let getInformationPrompt = () => {
      let balanceReminder = '';
      if (pageData.userInfo.customerCode === "CN371613") {
        if (Number(pageData.fundSituation.YYDDJE) > Number(pageData.fundSituation.SYKYED)) {
            balanceReminder = '剩余可用额度不足，请及时办理！'
          }
          else{
            balanceReminder =''
          }
      }
      // if (pageData.userInfo.customerCode === "CN370011" || pageData.userInfo.customerCode === "CN371613") {
        submitLoading.value = true;
        let alertCode = [];

        pageData.productList[0].proData.forEach((item, index) => {
          let data = {
            P_CUSTOMER_CODE: pageData.userInfo.customerCode,
            P_MATERIAL_CODE: item.code,
          };
          let params = {
            data: JSON.stringify(data),
            postType: "checkNumber",
          };

          proxy.$axios
            .postReq("/meide/REST/ajaxCheckNumber", params)
            .then((res) => {
              let qrderQuantity = Number(item.num);
              let monthlyData = Number(res.X_QUANTITY);
              if (qrderQuantity > monthlyData) {
                alertCode.push(item.code);

                if (index === pageData.productList[0].proData.length - 1) {
                  setTimeout(() => {

                    alertCode = alertCode.join("<br>");
                    ElMessageBox.confirm(
                      `<p style="color: red;">${balanceReminder}</p>
                      <p>${alertCode} </p> 产品已超贵司月均销量，是否确认?`,
                      "提示",
                      {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                      }
                    )
                      .then(() => {
                        settleSubmit();
                        submitLoading.value = false;
                      })
                      .catch(() => {
                        ElMessage({
                          type: "info",
                          message: "已取消",
                        });
                        submitLoading.value = false;
                      });

                  }, 600);
                }
              } else {
                if (index === pageData.productList[0].proData.length - 1) {
                  settleSubmit();
                  submitLoading.value = false;
                }
              }
            })
            .catch(function (error) {
              ElMessage({
                message: error.Info,
                type: "warning",
              });
            });
        });
      // } else {
        // settleSubmit();
        // submitLoading.value = false;
      // }
    };

    onBeforeMount(() => {
      pageData.orderNum = router.currentRoute.value.params.id;

      pageData.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      getAlmost("queryDistributors"); //分销商列表
      getPros(); //订单信息
      // getAlmost("queryInvoice"); // 销售公司列表

      getAlmost("queryAddress"); //地址列表
      getAlmost("queryPayType"); //  余额等信息
    });

    return {
      ...toRefs(pageData),
      getAlmost,
      selectItem,
      getPros,
      submitClick,
      getInformationPrompt,
      adrMoreS,
      backCart,
      fxsPayInfoList,
      handleBtn,
      status,
      showTable,
      changeCompany,
      getPayInfoList,
      changePayType,
      submitLoading,
      moneyCaution
    };
  },
};
</script>

<style scoped lang="scss">
.headbox {
  width: 1200px;
  margin: auto;
  justify-content: space-between;
  padding: 30px 0 15px 0;

  a {
    img {
      width: 165px;
    }
  }

  .stepbox {
    height: 60px;

    ::v-deep(.el-steps) {
      float: right;
      width: 500px;
    }
  }
}

.main {
  padding-bottom: 50px;

  h1 {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.maincon {
  width: 1200px;
  margin: auto;
  padding-top: 30px;
}

.tabs {
  justify-content: space-between;

  a {
    color: rgb(0, 144, 111);
  }
}

.cartbox {
  padding-bottom: 200px;

  .cartcon {
    .overview {
      background: #fafafa;
      padding: 20px 30px;
      border-top: 2px solid rgba(244, 36, 52, 1);
      justify-content: space-between;

      .left {
        .ordernum {
          padding: 5px 20px;
          color: #fff;
          background: rgba(244, 36, 52, 1);
          border-radius: 200px;
          display: inline-block;
        }

        .ordermsg {
          margin-top: 20px;

          span {
            font-size: 12px;
            color: #666;
          }
        }
      }

      .right {
        align-items: flex-start;

        p {
          font-size: 12px;
          color: #666;
        }

        .redw {
          font-size: 12px;
        }
      }
    }

    .ordercon {
      border: 1px solid rgba(215, 215, 215, 1);

      .item {
        h2 {
          padding: 15px 30px;
          background: #fafafa;
          border-top: 1px solid rgba(215, 215, 215, 1);

          p {
            font-size: 12px;
            color: #666;
            margin-right: 25px;
          }

          div {
            margin-right: 25px;

            span {
              font-size: 12px;
              color: #666;
              margin-right: 15px;
            }

            ::v-deep(.el-input--suffix .el-input__inner) {
              height: 30px;
            }

            ::v-deep(.el-input__icon) {
              line-height: 30px;
            }
          }
        }

        .cell {
          padding: 20px 15px;
          border: 1px solid rgb(235, 235, 235);

          &>div>p {
            color: #666;
            font-size: 12px;
          }

          &>div>p.redw {
            color: rgb(244, 36, 52);
            font-size: 14px;
          }

          div {
            margin: 0 2px;
          }

          .msg {
            width: 450px;

            .img {
              border: 1px solid rgb(235, 235, 235);
              margin-right: 10px;

              img {
                width: 102px;
                height: 102px;
              }
            }

            .name {
              span {
                font-size: 12px;
                display: block;
                margin-top: 5px;
              }
            }
          }

          .stock {
            width: 80px;
            text-align: center;
          }

          .deliver {
            width: 100px;
            text-align: center;
          }

          .price {
            width: 120px;
            text-align: center;
          }

          .num {
            width: 90px;
            text-align: center;
          }

          .cases {
            width: 90px;
            text-align: center;
          }

          .weight {
            width: 100px;
            text-align: center;
          }

          .total {
            flex-grow: 1;
            text-align: center;
          }
        }

        .note {
          padding: 20px 15px;
          justify-content: space-between;

          .notecon {
            span {
              font-size: 12px;
              width: 80px;
            }

            ::v-deep(.el-input__inner) {
              height: 30px;
              // width: 400px;
            }
          }

          .total {
            p {
              font-size: 12px;
              margin-left: 20px;
            }

            .largew {
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}

.selectedico {
  position: absolute;
  z-index: 99;
  bottom: 0;
  right: 0;
  width: 30px;
  height: 20px;

  img {
    width: 30px;
    height: 20px;
  }
}

.pay {
  margin-top: 30px;

  .con {
    border-top: 2px solid rgba(244, 36, 52, 1);
    padding: 30px;
    background: #fafafa;

    .cell {
      width: 230px;
      height: 150px;
      padding: 15px;
      background: #fff;
      position: relative;
      border-radius: 4px;
      margin: 0 15px;
      box-shadow: 5px 5px 16px rgb(0 0 0 / 11%);
      border: 1px solid #fff;

      .name {
        margin-bottom: 8px;

        p {
          padding-right: 20px;
          font-size: 13px;
        }
      }

      .msg {
        justify-content: space-between;

        img {
          width: 88px;
          height: 88px;
          opacity: 0.3;
        }

        div {

          // margin-left: 20px;
          p {
            font-size: 12px;
            margin-bottom: 5px;

            span {
              font-size: 12px;
            }
          }
        }
      }

      &:hover,
      &.on {
        border: 1px solid rgba(244, 36, 52, 1);
      }
    }
  }
}

.address {
  margin-top: 30px;

  .con {
    border-top: 2px solid rgba(244, 36, 52, 1);
    padding: 30px;
    background: #fafafa;
    flex-wrap: wrap;
    overflow: hidden;

    .cell {
      width: 240px;
      height: 165px;
      padding: 20px;
      background: #fff;
      position: relative;
      border-radius: 4px;
      margin: 10px 15px;
      box-shadow: 5px 5px 16px rgb(0 0 0 / 11%);

      .name {
        margin-bottom: 20px;

        p {
          margin-right: 15px;
          font-size: 16px;
        }
      }

      .msg {
        p {
          font-size: 12px;
          margin-bottom: 10px;

          span {
            font-size: 12px;
          }
        }
      }

      &:hover,
      &.on {
        border: 1px solid rgba(244, 36, 52, 1);
      }
    }
  }

  .adrmore {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #eee;
    color: #999;
    cursor: pointer;
  }
}

.totalall {
  margin-top: 30px;

  .con {
    border-top: 2px solid rgba(244, 36, 52, 1);
    padding: 30px;
    background: #fafafa;
    flex-direction: column;
    align-items: flex-end;

    p {
      width: 300px;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;

      span {
        color: #666;
      }

      span.redw {
        color: rgb(244, 36, 52);
      }

      .largew {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
}

.submitbtn {
  width: 150px;
  height: 45px;
  color: #fff;
  background-color: rgba(244, 36, 52, 1);
  text-align: center;
  line-height: 45px;
  margin-top: 40px;
  float: right;
  cursor: pointer;
}

.el-message-box__message {
  white-space: pre-line;
}
</style>
